// extracted by mini-css-extract-plugin
export default {"beneficiaries_form_wrapper":"ActivityForm_beneficiaries_form_wrapper__5osX+","form_action_wrapper":"ActivityForm_form_action_wrapper__2D4Ph"};